module.exports = __webpack_public_path__ + "static/media/logo.748dec9f.png";